import React, { useState, useContext } from "react";
import SearchBar from "./SearchBar";
import { IoIosArrowBack } from "react-icons/io";
import Image from "next/image";
import { AppContext } from "@/pages/_app";

export default function Navbar({ pageProps }) {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [btnType, setBtnType] = useState("button");
  
  const domain =
  pageProps?.domain ||
  (typeof window !== "undefined"
    ? window.location.hostname.substring(
        window.location.hostname.indexOf(".") + 1
      )
    : "");
    
  const countryCode = pageProps?.countryCode || "en";

  const { translation } = useContext(AppContext);

  const cancel = () => {
    setBtnType("button");
    setIsSearchBarOpen(false);
  };

  // Dynamic logo path based on country code from public/logos directory
  const logoSrc = `/logos/logo-${countryCode || 'en'}.png`;

  return (
    <>
      <nav className="bg-gray-450">
        <div className="flex justify-between items-center inner-container p-3 xl:p-0 xl:py-5">
          {isSearchBarOpen ? (
            <button onClick={cancel}>
              <IoIosArrowBack className="text-primary text-2xl" />
            </button>
          ) : (
            <a href={`https://www.${domain}/`}>
              <Image
                src={logoSrc}
                alt={`${domain} logo`}
                className="h-10"
                width="130"
                height="40"
                priority // Add priority to load logo quickly
              />
            </a>
          )}

          <SearchBar
            setIsSearchBarOpen={setIsSearchBarOpen}
            isSearchBarOpen={isSearchBarOpen}
            btnType={btnType}
            setBtnType={setBtnType}
            domain={domain}
            countryCode={countryCode}
          />
        </div>
      </nav>
      <div className="text-xs mx-auto table py-1 text-gray-400 text-center">
        {translation?.disclaimer}
      </div>
    </>
  );
}
